import Phaser from "phaser";

import type { DiscordBridge } from "./discord/DiscordBridge.ts";
import { MockDiscordBridge } from "./discord/MockDiscordBridge.ts";
import { RealDiscordBridge } from "./discord/RealDiscordBridge.ts";
import { BootScene } from "./scenes/BootScene.ts";
import { GameScene } from "./scenes/GameScene.ts";
import { COLORS } from "./ui/theme.ts";

function chooseBridge(): DiscordBridge {
  if (import.meta.env.VITE_DISCORD_MOCK === "1") return new MockDiscordBridge();
  return new RealDiscordBridge(import.meta.env.VITE_DISCORD_CLIENT_ID ?? "");
}

/** Last line of defense: an uncaught error must never leave the iframe blank. */
function showFatal(message: string): void {
  const root = document.getElementById("app") ?? document.body;
  root.innerHTML = "";
  const box = document.createElement("div");
  box.className = "fatal";
  box.textContent = `Odds Are hit a problem: ${message}`;
  root.appendChild(box);
}

window.addEventListener("error", (event) => showFatal(event.message));
window.addEventListener("unhandledrejection", (event) => {
  const reason: unknown = event.reason;
  showFatal(reason instanceof Error ? reason.message : String(reason));
});

const bridge = chooseBridge();

new Phaser.Game({
  type: Phaser.AUTO,
  parent: "app",
  backgroundColor: COLORS.background,
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: "100%",
    height: "100%",
  },
  // The first scene auto-starts, so the bridge rides in through its constructor.
  scene: [new BootScene(bridge), GameScene],
});
